/**
 * Created by Ning Jiang on 3/31/2020.
 */
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {DeadwoodIntroSlideShowPage} from "./DeadwoodIntroSlideShowPage";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {Deadwood} from "../Deadwood";

export class DeadwoodIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000,
            backgroundAlpha: 0.6,
            bulletColor: 0xffffff
        },
        stampColor: 0xFFFFFF,
    };

    stampConfig: StampConfig = {
        xWays: false,
        xNudge: true,
        volatility: Volatility.EXTREME
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    public static INTRO_BACKGROUND = "resources/images/intro/Background.jpg";
    public static INTRO_FEATURE_PICK = "nolimit/screens/images/FreespinPick.png";
    public static INTRO_FEATURE_WILDS = "nolimit/screens/images/HunterWilds.png";
    public static INTRO_FEATURE_SHOOTOUT = "resources/images/intro/ShootOut2.png";
    public static INTRO_FEATURE_PICK_US = "nolimit/screens/images/FreespinPick_US.png";
    public static INTRO_FEATURE_WILDS_US = "nolimit/screens/images/HunterWilds_US.png";
    public static INTRO_LOGO = "resources/images/intro/logo.png";
    private bgBlack: PIXI.Sprite;


    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(DeadwoodIntroConfig.INTRO_BACKGROUND, DeadwoodIntroConfig.INTRO_BACKGROUND);
        imgLoader.add(DeadwoodIntroConfig.INTRO_FEATURE_PICK, DeadwoodIntroConfig.INTRO_FEATURE_PICK);
        imgLoader.add(DeadwoodIntroConfig.INTRO_FEATURE_WILDS, DeadwoodIntroConfig.INTRO_FEATURE_WILDS);
        imgLoader.add(DeadwoodIntroConfig.INTRO_FEATURE_PICK_US, DeadwoodIntroConfig.INTRO_FEATURE_PICK_US);
        imgLoader.add(DeadwoodIntroConfig.INTRO_FEATURE_WILDS_US, DeadwoodIntroConfig.INTRO_FEATURE_WILDS_US);
        imgLoader.add(DeadwoodIntroConfig.INTRO_FEATURE_SHOOTOUT, DeadwoodIntroConfig.INTRO_FEATURE_SHOOTOUT);
        imgLoader.add(DeadwoodIntroConfig.INTRO_LOGO, DeadwoodIntroConfig.INTRO_LOGO);

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    onResize() {
        const bounds = NolimitApplication.screenBounds;
        this.bgBlack.width = bounds.width;
        this.bgBlack.height = bounds.height;
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgBlack = new PIXI.Sprite(PIXI.Texture.WHITE);
        bgBlack.anchor.set(0.5, 0.5);
        bgBlack.tint = 0x000000;
        this.bgBlack = bgBlack;
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture(DeadwoodIntroConfig.INTRO_BACKGROUND));
        bgSprite.anchor.set(0.5, 0.5);

        this.background.addChild(bgBlack);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        this.borderBottom = new PIXI.Container();

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture(DeadwoodIntroConfig.INTRO_LOGO));
        logoSprite.anchor.set(0.5);
        this.logo.addChild(logoSprite);

        this.pages = [
            new DeadwoodIntroSlideShowPage([ImgLoader.getImgTexture(DeadwoodIntroConfig.INTRO_FEATURE_WILDS), ImgLoader.getImgTexture(DeadwoodIntroConfig.INTRO_FEATURE_PICK)], [0.52, 0.65]),
            new DeadwoodIntroSlideShowPage([ImgLoader.getImgTexture(DeadwoodIntroConfig.INTRO_FEATURE_SHOOTOUT)], [0.52])
        ];

        if (Deadwood.api.gameClientConfiguration.isSet) {
            this.showMultiplierImage();
        } else {
            Deadwood.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.showMultiplierImage();
            });
        }
    }

    private showMultiplierImage() {
        if (!Deadwood.api.gameClientConfiguration.showMultipliersInfo) {
            if (this.pages[0].children.length > 0) {
                (<PIXI.Sprite>this.pages[0].children[0]).texture = ImgLoader.getImgTexture(DeadwoodIntroConfig.INTRO_FEATURE_WILDS_US);
                this.pages[0].children[0].scale.set(0.52, 0.52);
                (<PIXI.Sprite>this.pages[0].children[1]).texture = ImgLoader.getImgTexture(DeadwoodIntroConfig.INTRO_FEATURE_PICK_US);
                this.pages[0].children[1].scale.set(0.65, 0.65);
            }
        }
    }
}
